import { Response } from 'services/http';

const responseFulfilled = (value: Response): Response => value;

export default responseFulfilled;
